import request from "axios"

request.interceptors.response.use((res) => {
    return res
}, (err) => {
    if (err.response.status === 403) {
        window.location.href = "/login"
    }
    throw err
})

export default request
